import { ExternalSmsMarketingProvider } from "@redotech/redo-model/marketing";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getExternalSmsMarketingProviderStatus = {
  name: "getExternalSmsMarketingProviderStatus" as const,
  input: z.object({}),
  output: z.object({
    currentProvider: createEnum(ExternalSmsMarketingProvider).nullable(),
    integrations: z.object({
      attentive: z.object({
        exists: z.boolean(),
        hasRecoverPurpose: z.boolean(),
      }),
      klaviyo: z.object({
        exists: z.boolean(),
      }),
      postscript: z.object({
        exists: z.boolean(),
      }),
    }),
  }),
};
